module.exports = __webpack_public_path__ + "static/img/A (8).714ba83a.png";